import { CadetWormhole } from "../Views/CadetWormhole";

export function NotFoundPage() {
  return <CadetWormhole imgUrl="/img/404-text.png" />;
}
